import React, { useState, useEffect } from "react";
import api from "../../../../Axios/api";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Pal from "../../../../themes/palette";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import MaterialTable from "material-table";
import DeleteCategory from "../../../FormDialog/DeleteCategory";
import {
  Modal,
  Button,
  TextField,
  Container,
  Grid,
  Paper,
  Avatar,
  Typography,
} from "@material-ui/core";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import { Redirect } from "react-router-dom";
import { useUserContext } from "../../../../context/UserContext";
import useStyles from "./styles";

///////////////////////Form validations imports/////////////////////////////////
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

export default function AddCategoryVendor() {
  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const classes = useStyles();

  // context
  const { store } = useUserContext();
  const token = store.data.token;

  const [isLoggedOut, setIsLoggedOut] = useState(false);

  const [details, setDetails] = useState([]);
  const columns = [
    {
      title: "ID",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    { title: "Name", field: "name", hidden: false, export: true },
    {
      title: "Description",
      field: "description",
    },
  ];
  // Edit Product Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);
  const handleOpen = () => {
    setModelOpen(true);
  };
  const handleClose = () => {
    setModelOpen(false);
  };

  const [categoryDetails, setCategoryDetails] = useState({
    name: "test",
    description: "test",
  });

  const handleCategoryDetails = (input) => (e) => {
    setCategoryDetails({ ...categoryDetails, [input]: e.target.value });
  };

  // Delete Product Dialog
  const [isDeletingProduct, setIsDeletingProduct] = useState(false);
  // show delete Account Dialog
  const handlerAccountDelete = () => {
    setIsDeletingProduct(true);
  };
  // Delete Subject Handler
  const confirmedDelete = () => {
    const categoryId = categoryDetails._id;

    // api to delete product
    api
      .delete(`/admin/vendorCategory/${categoryId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // Removing deleted Product from details array
        const newDetails = details.filter((prod) => prod._id !== categoryId);
        setDetails(newDetails);
        setIsDeletingProduct(false);
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Category has been deleted!",
          open: true,
        });
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went wrong!",
          open: true,
        });
      });
  };

  const retrivingAllCategories = async () => {
    await api
      .get("/admin/vendorCategories", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setDetails(res.data.data.categories);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  const editCategoryHandler = (e) => {
    const categoryId = categoryDetails._id;
    e.preventDefault();

    api
      .patch(
        `/admin/vendorCategory/${categoryId}`,
        {
          ...categoryDetails,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        const newDetails = details.map((prod) =>
          prod._id === categoryId ? categoryDetails : prod
        );
        setDetails(newDetails);
        handleClose();
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Category has been Updated!",
          open: true,
        });
      })
      .catch(() => {
        handleClose();
        setSnackBar({
          ...snackBarstate,
          message: "ERROR: Something is not working properly!",
          type: "error",
          open: true,
        });
      });
  };

  const initialValues = {
    name: "",
    description: "",
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string().min(3).required("Required*"),
    description: Yup.string().required("Required*"),
  });
  const onSubmit = (values, props) => {
    console.log(props);
    console.log(values);
    api
      .post(
        "/admin/vendorCategory",
        {
          ...values,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        console.log(res.data);
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Vendor Category Added Successfully!",
          open: true,
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) =>
        setSnackBar({
          ...snackBarstate,
          message: "ERROR: Fill all the fields first!!",
          type: "error",
          open: true,
        })
      );
  };

  useEffect(() => {
    // Retriving List of Products from API
    retrivingAllCategories();
  }, []);

  return (
    <Grid container className={classes.root}>
      {isLoggedOut ? <Redirect to="/admin/login" /> : ""}
      <Grid item xs={12} sm={12} md={12} component={Paper}>
        <Container component="div" maxWidth="sm">
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LibraryAddIcon />
            </Avatar>
            <Typography variant="h5">Add Category For Vendors</Typography>
            <Grid className={classes.settingsSpacing}>
              <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
              >
                {(props) => (
                  <Form className={classes.form}>
                    <Field
                      as={TextField}
                      autoFocus
                      variant="outlined"
                      margin="normal"
                      id="name"
                      label="Category Name"
                      name="name"
                      fullWidth
                      required
                      helperText={<ErrorMessage name="name" />}
                    />
                    <Field
                      as={TextField}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="description"
                      label="Category Description"
                      name="description"
                      required
                      helperText={<ErrorMessage name="description" />}
                    />
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                    >
                      Add Category
                    </Button>
                  </Form>
                )}
              </Formik>
            </Grid>
          </div>
        </Container>
        <Grid item xs={12} sm={12} md={12} component={Paper}>
          <MaterialTable
            style={{ width: 1000 }}
            title="All Categories"
            data={details}
            columns={columns}
            actions={[
              (rowData) => ({
                icon: () => <EditIcon />,
                tooltip: "Edit",
                onClick: (event, rowData) => {
                  setCategoryDetails(rowData);
                  handleOpen();
                },
              }),
              (rowData) => ({
                icon: () => <DeleteIcon />,
                tooltip: "Delete",
                onClick: (event, rowData) => {
                  setCategoryDetails(rowData);
                  handlerAccountDelete();
                },
              }),
            ]}
            options={{
              actionsColumnIndex: -1,
              headerStyle: {
                backgroundColor: Pal.palette.primary.main,
                color: "#fff",
                fontWeight: "bold",
              },
              exportButton: true,
              tableLayout: "auto",
            }}
            localization={{
              pagination: {
                labelRowsSelect: "Rows per page",
              },
            }}
          />
        </Grid>
        <Snackbar
          open={open}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
          key={vertical + horizontal}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseSnackBar}
            severity={snackBarstate.type}
          >
            {snackBarstate.message}
          </MuiAlert>
        </Snackbar>
      </Grid>

      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container
          component={Paper}
          style={{
            padding: "20px",
            maxWidth: "50vw",
            maxHeight: "80vh",
            overflow: "auto",
            scrollbarWidth: "2px",
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} align="center">
              <Typography variant="h5">Edit Category</Typography>
            </Grid>
            <form className={classes.form} noValidate style={{ padding: 20 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    autoFocus
                    margin="dense"
                    variant="outlined"
                    autoComplete="pName"
                    required
                    fullWidth
                    label="Name"
                    name="name"
                    value={categoryDetails.name}
                    onChange={handleCategoryDetails("name")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    multiline
                    rows={4}
                    label="Description"
                    value={categoryDetails.description}
                    onChange={handleCategoryDetails("description")}
                  />
                </Grid>
                {/* SAVE CHANGES BUTTON */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  align="center"
                  style={{ margin: "20px 0" }}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: 10 }}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={editCategoryHandler}
                  >
                    Save Changes
                  </Button>
                </Grid>
              </Grid>

              <Snackbar
                open={open}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={handleCloseSnackBar}
                key={vertical + horizontal}
              >
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  onClose={handleCloseSnackBar}
                  severity={snackBarstate.type}
                >
                  {snackBarstate.message}
                </MuiAlert>
              </Snackbar>
            </form>
          </Grid>
        </Container>
      </Modal>

      {/* Delete Confirmation Dialog */}

      <DeleteCategory
        DeletingProduct={isDeletingProduct}
        setDeletingProduct={setIsDeletingProduct}
        confirmedDelete={confirmedDelete}
      />
    </Grid>
  );
}
